<template>
  <article>
    <div ref="header">
      <search-input v-model="queryForm.keyword" placeholder-word="请输入车牌号码" @on-search="search"></search-input>
    </div>
    <tab-list
      :status.sync="tabStatus"
      :tab-list="tabList"
      @tab-change="handleTabChange">
    </tab-list>
    <scroller
      v-model="status"
      lock-x scrollbar-y
      use-pullup
      use-pulldown
      :height="scrollerHeight"
      @on-pullup-loading="loadMore"
      @on-pulldown-loading="getData"
      :pullup-config="{content:'',upContent:'',downContent:'',loadingContent:'加载中...'}"
      :pulldown-config="{content:'',upContent:'',downContent:'',loadingContent:'更新中...'}"
      v-if="totalCount">
      <div class="mt-20 related-to-me">
        <group v-for="(item,index) in dataList" :key="index" class="mt-20">
          <!--<cell @click.native="onShowDetail(item.visit)" class="all_list">-->
          <cell @click.native="checkDetail(item)" class="all_list">
            <p slot="after-title" class="title" v-if="tabStatus !== 'unlicensed_requisitions'">{{item.visit.plate_number}} {{item.visit.insurance_rating ? `（保险${item.visit.insurance_rating}类）`:''}}<img :src="item.visit.brand_image_url" alt="" v-if="item.visit.brand_image_url"></p>
            <p slot="after-title" class="title" v-else>{{item.vin || item.phone_number }}</p>

            <p slot="after-title" class="detail" v-if="tabStatus === 'steps'">进店：{{item.visit.visited_at | hideSecond}} {{item.visit.is_entered_workshop ? '（已进车间）':'（未进车间）'}}</p>
            <p slot="after-title" class="detail" v-if="tabStatus === 'requisition'">提交时间：{{item.requisition_at | hideSecond}}</p>
            <p slot="after-title" class="detail" v-if="tabStatus === 'unlicensed_requisitions'">申请时间：{{item.apply_time | hideSecond}}</p>
            <div class="identifications">
              <span class="identification this-product" v-if="item.visit.is_self_brand">本品</span>
            </div>
          </cell>
          <cell>
            <!--<div slot="value" class="operate_btn" v-if="item.step_no ===1">-->
              <!--<x-button mini plain type="primary" @click="checkDetail(item)">查看进度</x-button>-->
            <!--</div>-->
            <div slot="value" class="operate_btn">
              <x-button
                mini plain
                type="primary"
                @click="showModal('reject', item.exiting_process_id, item.step_id, index)"
                v-if="item.status_code==='pending_review'"
                class="not_pass">
                <em></em>驳回
              </x-button>
              <x-button
                mini plain
                type="primary"
                @click="onUpdate('approve', item.exiting_process_id, item.step_id, index)"
                v-if="item.status_code==='pending_review'"
                class="agreed_pass">
                <em></em>同意
              </x-button>
              <span class="reject-btn" @click="handleShowConfirmTxet(item.reject_reason)" v-if="item.reject_reason">驳回原因</span>
              <span v-if="item.status_code==='rejected' && !item.reject_reason">已驳回</span>
              <span v-if="item.status_code==='approved'">已同意</span>
              <span v-if="item.status_code==='canceled'">已取消</span>
              <span v-if="item.status_code==='not_started'">待确认</span>
            </div>
          </cell>
        </group>
        <p class="tip-text1">共{{totalCount}}条记录</p>
      </div>
    </scroller>
    <no-car v-else></no-car>

    <Alert
      ref="checkListAlertRef"
      :title="alertInfo.title"
      confirmText='确认'
    >
      <div class="reject-confirm__text">{{alertInfo.text}}</div>
    </Alert>

    <RejectReasonConfirm
      @success="handleReject"
      ref="rejectReasonConfirm"
    />
  </article>
</template>
<script>
import {
  XButton,
  Scroller,
  Cell,
  Group
} from '@lx-frontend/cvux'
import SearchInput from '../components/SearchInput'
import Alert from '../components/Alert.vue'
import NoCar from '../components/NoCar'
import RejectReasonConfirm from '../components/RejectReasonConfirm'
import TabList from '../components/TabList'

export default {
  components: {
    SearchInput,
    NoCar,
    XButton,
    Scroller,
    Cell,
    Group,
    TabList,
    Alert,
    RejectReasonConfirm
  },
  data() {
    return {
      isChecking: false,
      status: {
        pulldownStatus: 'default'
      },
      statusMap: {
        approve: 'approved',
        reject: 'rejected'
      },
      queryForm: {
        page: 1,
        count: 10,
        keyword: ''
      },
      totalCount: 0,
      totalPage: 0,
      dataList: [],
      scrollerHeight: '',
      tabStatus: 'steps',
      tabList: [
        { key: 'steps', name: '放行流程处理' },
        { key: 'requisition', name: '客户放行申请' },
        { key: 'unlicensed_requisitions', name: '无牌放行申请' }
      ],
      alertInfo: {
        title: '',
        text: ''
      }
    }
  },
  mounted() {
    this.scrollerHeight = `-${this.$refs.header.offsetHeight}px`
    this.getData()
  },
  filters: {
    // 隐藏日期中的秒
    hideSecond(dateStr) {
      return (dateStr || '').replace(/:\d{2}$/, '')
    }
  },
  watch: {
    dataList(val) { // 避免数据太大造成浏览器内存溢出，暂定50条
      let len = val.length
      let count = this.queryForm.count
      if (len > 50) val.splice(0, count)
    }
  },
  methods: {
    handleTabChange() {
      this.queryForm.page = 1
      this.totalCount = 0
      this.totalPage = 0
      this.getData()
    },
    search() {
      this.queryForm.page = 1
      this.totalCount = 0
      this.totalPage = 0
      this.getData()
    },
    getData() {
      this.switchLoading({ status: true, text: '加载中...' })

      this.$rest.barriergate.getCheckFlowList(this.tabStatus)(this.queryForm).then(res => {
        if (res.code === 0) {
          let data = res.data
          let count = this.queryForm.count
          this.dataList = data.review_process_steps
          this.totalCount = data.total_count
          this.totalPage = parseInt((this.totalCount + count - 1) / count)
          this.status.pulldownStatus = 'default'
        } else {
          this.showToast(res.message)
        }
        this.switchLoading({ status: false })
      })
    },
    loadMore(done) {
      if (this.queryForm.page < this.totalPage) {
        this.queryForm.page++
        this.$rest.barriergate.getCheckFlowList(this.tabStatus)(this.queryForm).then(res => {
          if (res.code === 0) {
            let data = res.data
            let count = this.queryForm.count
            this.totalCount = data.total_count
            this.totalPage = parseInt((this.totalCount + count - 1) / count)
            this.dataList.push(...data.review_process_steps)
            done(100)
          } else {
            this.showToast(res.message)
          }
        })
      } else {
        done()
      }
    },
    // onShowDetail(visit) {
    //   let info = [
    //     { car_id: visit.car_id },
    //     { plate_number: visit.plate_number }
    //   ]
    //   this.$router.push({
    //     path: '/cus_info',
    //     query: visit.insurance_rating ? info[0] : info[1]
    //   })
    // },
    checkDetail(item) {
      let exitingProcessId = item.exiting_process_id
      let visitId = item.visit.visit_id
      let processId = item.workflow_id
      let requisitionId = item.requisition_id
      if (this.tabStatus === 'steps') {
        this.$router.push(`/barriergate/flow/detail/${visitId}/${exitingProcessId}`)
      } else if (this.tabStatus === 'unlicensed_requisitions') {
        this.$router.push(`/barriergate/flow/detail/${visitId}/${exitingProcessId}?notPlate=1&phone_number=${item.phone_number || ''}&vin=${item.vin}`)
      } else {
        this.$router.push(`/barriergate/audit/progress/${visitId}/${processId}?requisition_id=${requisitionId}`)
      }
    },
    onUpdate(status, processId, stepId, index) {
      if (this.isChecking) {
        return false
      }
      this.isChecking = true
      const params = {
        action: status
      }
      if (status === 'reject') params.reason = this.rejectReason
      this.$rest.barriergate.updateCheckState(params, `${processId}/steps/${stepId}/${status}`).then((res) => {
        if (res.code === 0) {
          this.dataList[index].status_code = this.statusMap[status]
          this.dataList[index].reject_reason = this.rejectReason
        } else {
          this.showToast(res.message)
        }
        this.isChecking = false
      })
    },
    showModal(...currentRecord) {
      this.$refs.rejectReasonConfirm.changeShow(true, currentRecord)
    },
    handleReject({ reason, backInfo }) {
      this.rejectReason = reason
      this.onUpdate(...backInfo)
    },
    handleShowConfirmTxet(text) {
      this.$refs.checkListAlertRef.changeShow(true)
      this.alertInfo = {
        text,
        title: '驳回原因'
      }
    }
  }
}

</script>
<style scoped lang="less">
  @import "../../stylesheets/modules/barriergate/list.less";
</style>
